import { useCallback } from 'react';
import { TypeProps } from './TypeProps';
import classNames from 'classnames';
import IconArrow from './icons/arrow.svg';

import styles from './NavigationBar.module.scss';

export const NavigationBar = ({ countAll, active, setActive }: TypeProps): JSX.Element => {
  const handlerNextBanner = useCallback(() => {
    countAll - 1 < active + 1 ? setActive(0) : setActive(active + 1);
  }, [active]);
  return (
    <>
      <div className={styles.WrapperButton}>
        <div onClick={handlerNextBanner} className={styles.NextButton}>
          <IconArrow width={6} height={12} />
        </div>
      </div>
      <div className={styles.ButtonContainer}>
        {Array.from(Array(countAll).keys()).map((item, index) => (
          <div onClick={() => setActive(index)} className={classNames(styles.Button, index === active && styles.Active)} key={index}></div>
        ))}
      </div>
    </>
  );
};
